export const useIsTouchDevice = () => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0
}
